export default function HowItWorks() {
  const steps = [
    {
      number: "01",
      title: "Capture Your Recipe",
      description:
        "Take a photo of any recipe from cookbooks, magazines, or handwritten notes. Our advanced OCR technology handles any format.",
    },
    {
      number: "02",
      title: "AI Processes & Organizes",
      description:
        "Our AI extracts ingredients, instructions, and metadata, organizing everything into a clean, searchable format.",
    },
    {
      number: "03",
      title: "Plan & Cook",
      description:
        "Build meal plans, generate shopping lists, and follow step-by-step instructions. Your recipes, perfectly organized.",
    },
  ];

  return (
    <section id="how-it-works" className="py-20 px-6 bg-white">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-4">How It Works</h2>
          <p className="text-xl text-neutral-600 max-w-2xl mx-auto">
            From recipe to plate in three simple steps
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-primary-100 text-primary-600 text-3xl font-bold mb-6">
                {step.number}
              </div>
              <h3 className="text-2xl font-semibold text-neutral-900 mb-3">{step.title}</h3>
              <p className="text-neutral-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
